import React, { useEffect, useMemo, useState } from "react";
import {
  ClegIcon,
  CustomIcon,
  IronIcon,
  StoneIcon,
} from "../../components/Icons";
import Network from "../../utils/Network";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import Slider from "rc-slider";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { useAppTranslation } from "../../i18n/useAppTranslation";
type Props = {};

const Buildings = (props: Props) => {
  const { t } = useAppTranslation("learn");
  const [data, setData] = useState([]);
  const [active, setActive] = useState(3);
  const [level, setLevel] = useState(1);
  const axios = new Network();
  const currentCycle = useSelector((state: any) => state.currentCycle);

  const handleGetData = async () => {
    const response = await axios.CallApi({
      url: "/building/all",
      method: "get",
    });
    setData(response.data);
  };

  useEffect(() => {
    handleGetData();
  }, []);

  const activeTabData: any = React.useMemo(() => {
    if (data) {
      return data?.find((item: any) => item.id === active);
    }
  }, [data, active]);

  const PhotoUrl =
    "https://core.chainoflegends.com/Admin/files/Photos/Buildings";
  const buildingInfo = activeTabData?.buildingInfos?.[active === 3 ? level : level - 1];
  const buildingDescriptions = {
    3: (
      <>
        {t("learn:buildings.descriptions.clegMiner.part1")}{" "}
        <Link to="/lands">{t("learn:buildings.descriptions.clegMiner.lands")}</Link>.
        {` ${t("learn:buildings.descriptions.clegMiner.part2")} `}
        <ClegIcon width={20} height={20} /> {t("learn:buildings.resources.cleg")},
        <StoneIcon width={20} height={20} /> {t("learn:buildings.resources.stone")},
        {` ${t("learn:buildings.labels.and")} `}
        <IronIcon width={20} height={20} /> {t("learn:buildings.resources.iron")}.
      </>
    ),
    4: (
      <>
        {t("learn:buildings.descriptions.stoneMiner")}{" "}
        <Link to="/lands">{t("learn:buildings.descriptions.clegMiner.lands")}</Link>.
      </>
    ),
    5: (
      <>
        {t("learn:buildings.descriptions.stoneMiner")}{" "}
        <Link to="/lands">{t("learn:buildings.descriptions.clegMiner.lands")}</Link>.
      </>
    ),
    6: <>{t("learn:buildings.descriptions.barracks")}</>,
    7: <>{t("learn:buildings.descriptions.research")}</>,
  };

  return (
    <div>
      <div className="py-4 mt-4 rounded bg-2">
        <div className="d-flex gap-2 flex-wrap justify-content-center">
          {tabs?.map((item) => (
            <div onClick={() => setActive(item.id)}>
              <div className="main-tab-btn learn p-0 pointer no-hover">
                <img
                  className="img-fluid"
                  src={`/assets/images/buttons/${active === item.id
                    ? "active-tab-btn.png"
                    : "off-tab-btn.png"
                    }`}
                />
                <div className="b-text d-flex align-items-center justify-content-center px-3 text-light">
                  <span>
                    {item.icon}&nbsp;
                    {t(item.titleKey)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="my-4 text-white p-2 py-4 bg-2 rounded">
        <div className="row ">
          <div className="col-md-6 text-center col-12">
            <img
              style={{ maxWidth: 500 }}
              width={"100%"}
              src={activeTabData?.photoFile
                ? PhotoUrl + `/${active}/${activeTabData.photoFile}`
                : active === 7 ? "/assets/images/map/built/research.png" : undefined}
            />
          </div>
          <div className="col-md-6 col-12">
            <div className="fs-big bold ">{activeTabData?.name || (active === 7 ? t("learn:buildings.tabs.research") : "")}</div>
            <div className="text-secondary mt-2">
              {buildingDescriptions[active]}
            </div>
            {active === 7 ? (
              <div className="mt-3" style={{ overflowX: "auto" }}>
                <table className="table table-borderless m-0 text-white text-center">
                  <thead>
                    <tr>
                      <th scope="col">{t("learn:buildings.researchTable.level")}</th>
                      <th scope="col">{t("learn:buildings.researchTable.price")}</th>
                      <th scope="col">{t("learn:buildings.researchTable.cost")}</th>
                      <th scope="col">{t("learn:buildings.researchTable.queue")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {researchLevels.map((row) => (
                      <tr key={row.level}>
                        <td>{row.level}</td>
                        <td>{row.price.toLocaleString()}</td>
                        <td>{row.cost.toLocaleString()}</td>
                        <td>{row.queue}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : <>
            <div className="learn-line mt-3 d-flex flex-column gap-4">
              <div className="line-item">
                {t("learn:buildings.labels.capacity")} :{" "}
                <CountUp
                  separator=","
                  duration={0.44}
                  end={
                    buildingInfo?.capacity *
                    (active === 6
                      ? 1
                      : currentCycle?.ReductionMultiplier)
                  }
                />
              </div>
              <div className="line-item">
                {t("learn:buildings.labels.health")} :{" "}
                <CountUp separator="," duration={0.44} end={100} />
              </div>
              <div className="line-item">
                {active === 6 ? <>
                  {t("learn:buildings.labels.dailyHealing")}
                </> : <>
                  {t("learn:buildings.labels.dailyProduction")}
                </>}
                :{" "}
                <CountUp
                  separator=","
                  duration={0.44}
                  end={
                    buildingInfo?.dailyProduction *
                    (active === 6
                      ? 1
                      : currentCycle?.ReductionMultiplier)
                  }
                />
              </div>
              <div className="line-item">
                <motion.span
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1 }}
                >
                  {t("learn:buildings.labels.cost")} :
                  <CountUp
                    separator=","
                    duration={0.44}
                    end={buildingInfo?.clegCost}
                  />{" "}
                  <ClegIcon width={20} height={20} />
                </motion.span>
                {Boolean(buildingInfo?.stoneCost) && (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                  >
                    |{" "}
                    <CountUp
                      separator=","
                      duration={0.44}
                      end={buildingInfo?.stoneCost}
                    />{" "}
                    <StoneIcon width={20} height={20} />
                  </motion.span>
                )}
                {Boolean(buildingInfo?.ironCost) && (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                  >
                    |{" "}
                    <CountUp
                      separator=","
                      duration={0.44}
                      end={buildingInfo?.ironCost}
                    />{" "}
                    <IronIcon width={20} height={20} />
                  </motion.span>
                )}
              </div>
              {active !== 6 && <div className="line-item">
                {t("learn:buildings.labels.repairCost")} :
                <CountUp separator="," duration={0.44}
                  end={buildingInfo?.value * 0.1 * currentCycle?.ReductionMultiplier} /> <ClegIcon width={20} height={20} />
              </div>}
              <div className="line-item">
                {t("learn:buildings.labels.upgradeTime")} :{" "}
                <CountUp duration={0.77} end={buildingInfo?.upgradeTime} />{" "}
                {t("learn:buildings.labels.hours")}
              </div>
            </div>
            <div className="mt-4 pe-4">
              <Slider
                step={1}
                value={level}
                onChange={(val) => setLevel(val as number)}
                max={8}
                min={1}
                marks={{ 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8 }}
              />
            </div>
            </>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Buildings;
const tabs = [
  {
    titleKey: "learn:buildings.tabs.clegMiner",
    id: 3,
    icon: <ClegIcon />,
  },
  {
    titleKey: "learn:buildings.tabs.stoneMiner",
    id: 4,
    icon: <StoneIcon />,
  },
  {
    titleKey: "learn:buildings.tabs.ironMiner",
    id: 5,
    icon: <IronIcon />,
  },
  {
    titleKey: "learn:buildings.tabs.barracks",
    id: 6,
    icon: <CustomIcon icon="blades" />,
  },
  {
    titleKey: "learn:buildings.tabs.research",
    id: 7,
    icon: <CustomIcon icon="learn-book" />,
  },
];

// The building API does not expose Research levels, so they are listed here.
const researchLevels = [
  { level: 1, price: 1000, cost: 1000, queue: 1 },
  { level: 2, price: 1000, cost: 2000, queue: 1 },
  { level: 3, price: 2000, cost: 4000, queue: 1 },
  { level: 4, price: 4000, cost: 8000, queue: 2 },
  { level: 5, price: 8000, cost: 16000, queue: 2 },
  { level: 6, price: 16000, cost: 32000, queue: 2 },
  { level: 7, price: 32000, cost: 64000, queue: 3 },
  { level: 8, price: 64000, cost: 128000, queue: 3 },
];
